import { networkCall } from "../../../../../utils/network-call/network-call";

export const AdminDeletedCompanyListLoader = async () => {
    const getCompaniesResponse = await networkCall('/companies', {
        params: { deleted: 'true' }
    });
    return { getCompaniesResponse };
};